export default class InitiateError {
  message: string;

  constructor(message: string) {
    this.message = message;
  }
}
